import Axios from "axios"

export default {

  /**
   * 以图搜人
   */
  searchByPicture(
    attachment_id,
    similar
  ) {
    return Axios.post(`${process.env.VUE_APP_PREFIX}/face/search`, {
      attachment_id,
      similar
    });
  },
  
  /**
   * 获取图片路径
   * @param {*} attachmentId 
   */
  searchGetUrl(
    attachmentId
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/system/service/attachment/${attachmentId}`)
  }

}